(function () {
  "use strict";

  var reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var hasGSAP = typeof window.gsap !== "undefined";
  if (hasGSAP && window.ScrollTrigger) {
    gsap.registerPlugin(ScrollTrigger);
  }

  /* ---- Header shrink ---- */
  var header = document.querySelector("[data-header]");
  if (header) {
    var onScroll = function () {
      if (window.scrollY > 40) {
        header.classList.add("is-shrunk");
      } else {
        header.classList.remove("is-shrunk");
      }
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  /* ---- Mobile hamburger ---- */
  var hamburger = document.querySelector("[data-hamburger]");
  var mobileMenu = document.querySelector("[data-mobile-menu]");
  if (hamburger && mobileMenu) {
    hamburger.addEventListener("click", function () {
      var isOpen = mobileMenu.classList.toggle("is-open");
      hamburger.setAttribute("aria-expanded", isOpen ? "true" : "false");
    });
  }

  /* ---- FAQ accordion: CSS grid-rows driven, class-based (no hidden attr) ---- */
  var faqItems = document.querySelectorAll(".faq__item");
  faqItems.forEach(function (item) {
    var trigger = item.querySelector("[data-faq-trigger]");
    var panel = item.querySelector("[data-faq-panel]");
    if (!trigger || !panel) return;
    panel.removeAttribute("hidden");
    trigger.addEventListener("click", function () {
      var isOpen = item.classList.toggle("is-open");
      trigger.setAttribute("aria-expanded", isOpen ? "true" : "false");
    });
  });

  /* ---- Aurora blob parallax on scroll ---- */
  var blobs = document.querySelectorAll("[data-aurora-blob]");
  if (blobs.length && !reduceMotion) {
    window.addEventListener(
      "scroll",
      function () {
        var y = window.scrollY;
        blobs.forEach(function (blob, i) {
          var speed = i % 2 === 0 ? 0.06 : -0.05;
          blob.style.transform = "translateY(" + y * speed + "px)";
        });
      },
      { passive: true }
    );
  }

  /* ==========================================================================
     Word-mask text reveal -- wraps each word of a heading in a masked span
     so it can slide up into view. Runs at parse time, before any animation,
     so if GSAP fails to load the words are simply visible (progressive
     enhancement, no permanently-hidden content).
     ========================================================================== */
  function splitWords(el) {
    if (!el || el.dataset.split === "done") return [];
    var text = el.textContent.trim();
    var words = text.split(/\s+/);
    el.innerHTML = words
      .map(function (w) {
        return '<span class="word-mask"><span class="word-inner">' + w + "</span></span>";
      })
      .join(" ");
    el.dataset.split = "done";
    return Array.prototype.slice.call(el.querySelectorAll(".word-inner"));
  }

  var headingSelectors = [".hero__headline", ".section-head__title", ".blog-hero__headline", ".article__title"];
  var headingEls = document.querySelectorAll(headingSelectors.join(","));

  if (hasGSAP && !reduceMotion) {
    headingEls.forEach(function (el, index) {
      var words = splitWords(el);
      if (!words.length) return;
      var isHero = el.classList.contains("hero__headline");
      var tween = {
        yPercent: 130,
        duration: 0.9,
        ease: "power3.out",
        stagger: 0.045
      };
      if (isHero) {
        gsap.from(words, tween);
      } else {
        gsap.from(words, Object.assign({}, tween, {
          scrollTrigger: { trigger: el, start: "top 88%" }
        }));
      }
    });
  }

  /* ---- Hero load choreography: subhead, ctas, badges, flap panel ---- */
  if (hasGSAP && !reduceMotion) {
    var heroSubhead = document.querySelector(".hero__subhead");
    var heroCtas = document.querySelector(".hero__ctas");
    var heroBadges = document.querySelectorAll(".hero__badges > *");
    var tl = gsap.timeline({ delay: 0.25 });
    if (heroSubhead) tl.from(heroSubhead, { opacity: 0, y: 16, duration: 0.7, ease: "power2.out" }, 0.35);
    if (heroCtas) tl.from(heroCtas, { opacity: 0, y: 16, duration: 0.7, ease: "power2.out" }, 0.45);
    if (heroBadges.length) tl.from(heroBadges, { opacity: 0, y: 12, duration: 0.5, ease: "power2.out", stagger: 0.08 }, 0.55);
  } else if (!hasGSAP) {
    /* No animation library available -- content stays visible, no-op. */
  }

  /* ---- Split-flap hero panel: flip-in once, staggered per character ---- */
  var flapPanels = document.querySelectorAll("[data-flap-panel]");
  if (flapPanels.length && "IntersectionObserver" in window) {
    var flapObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-flipped");
            flapObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.4 }
    );
    flapPanels.forEach(function (el) {
      flapObserver.observe(el);
    });
  } else {
    flapPanels.forEach(function (el) {
      el.classList.add("is-flipped");
    });
  }

  /* ==========================================================================
     SVG icon draw-in -- every icon in this theme is stroke-based (fill:none),
     so each shape's outline can be measured and animated from invisible to
     fully drawn as its card scrolls into view.
     ========================================================================== */
  var iconWrapSelectors = [
    ".option-card__icon svg",
    ".checklist__icon svg",
    ".qualification__icon svg",
    ".embedded-map__icon svg",
    ".trust-badge__icon svg"
  ];
  var iconSvgs = document.querySelectorAll(iconWrapSelectors.join(","));

  if (hasGSAP && !reduceMotion) {
    iconSvgs.forEach(function (svg) {
      var shapes = svg.querySelectorAll("path, circle, rect");
      var lengths = [];
      shapes.forEach(function (shape) {
        var len = 0;
        try {
          len = shape.getTotalLength ? shape.getTotalLength() : 0;
        } catch (e) {
          len = 0;
        }
        lengths.push(len);
        if (len > 0) {
          shape.style.strokeDasharray = len;
          shape.style.strokeDashoffset = len;
        }
      });
      gsap.to(shapes, {
        strokeDashoffset: 0,
        duration: 0.9,
        ease: "power2.out",
        stagger: 0.08,
        scrollTrigger: { trigger: svg, start: "top 90%" }
      });
    });
  }

  /* ---- Card / grid group stagger reveals ---- */
  var staggerGroups = [".loan-options__grid", ".qualification__grid", ".blog-cards__grid", ".main-blog__grid"];
  if (hasGSAP && !reduceMotion) {
    staggerGroups.forEach(function (selector) {
      var grid = document.querySelector(selector);
      if (!grid) return;
      var items = Array.prototype.slice.call(grid.children);
      if (!items.length) return;
      gsap.from(items, {
        opacity: 0,
        y: 28,
        duration: 0.7,
        ease: "power2.out",
        stagger: 0.09,
        scrollTrigger: { trigger: grid, start: "top 85%" }
      });
    });
  }

  /* ---- Generic reveal-snap hook (trust-security stat, steps, etc.) ---- */
  var revealSnapEls = document.querySelectorAll(".reveal-snap");
  if (hasGSAP && !reduceMotion) {
    revealSnapEls.forEach(function (el) {
      gsap.from(el, {
        opacity: 0,
        y: 24,
        duration: 0.8,
        ease: "power2.out",
        scrollTrigger: { trigger: el, start: "top 85%" }
      });
    });
  } else if (!hasGSAP) {
    revealSnapEls.forEach(function (el) {
      el.style.opacity = 1;
    });
  }

  /* ---- Image reveal wipe (blog card + article images) ---- */
  var revealImages = document.querySelectorAll(".blog-card__img-wrap img, .article__img-wrap img");
  if (hasGSAP && !reduceMotion) {
    revealImages.forEach(function (img) {
      gsap.fromTo(
        img,
        { clipPath: "inset(0 0 100% 0)", scale: 1.12 },
        {
          clipPath: "inset(0 0 0% 0)",
          scale: 1,
          duration: 1,
          ease: "power3.out",
          scrollTrigger: { trigger: img, start: "top 92%" }
        }
      );
    });
  }

  /* ---- Snap stepper: markers fill instantly, staggered on scroll ---- */
  var stepMarkers = document.querySelectorAll("[data-step-marker]");
  if (stepMarkers.length && "IntersectionObserver" in window) {
    var stepObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var index = Array.prototype.indexOf.call(stepMarkers, entry.target);
            var delay = Math.max(index, 0) * 90;
            window.setTimeout(function () {
              entry.target.classList.add("is-filled");
            }, delay);
            stepObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.6 }
    );
    stepMarkers.forEach(function (el) {
      stepObserver.observe(el);
    });
  } else {
    stepMarkers.forEach(function (el) {
      el.classList.add("is-filled");
    });
  }
})();